import { MoverDialogMode, APITaskState } from './model';
import { CHNode, NodeLabel } from '../../../general/node';
import { createAction } from '@reduxjs/toolkit';
export const triggerButtonClicked = createAction<
  { mode: MoverDialogMode },
  'creativeHub/mover/triggerButtonClicked'
>('creativeHub/mover/triggerButtonClicked');
export const dialogOpened = createAction<
  { mode: MoverDialogMode; sourceNodeID: number },
  'creativeHub/mover/dialogOpened'
>('creativeHub/mover/dialogOpened');
export const dialogClosed = createAction<void, 'creativeHub/mover/dialogClosed'>(
  'creativeHub/mover/dialogClosed',
);
export const modalCloseUiEvent = createAction<void, 'creativeHub/mover/modalCloseUiEvent'>(
  'creativeHub/mover/modalCloseUiEvent',
);
export const confirmButtonClicked = createAction<void, 'creativeHub/mover/confirmButtonClicked'>(
  'creativeHub/mover/confirmButtonClicked',
);
export const cancelButtonClicked = createAction<void, 'creativeHub/mover/cancelButtonClicked'>(
  'creativeHub/mover/cancelButtonClicked',
);

export const setInprogress = createAction<
  { inProgress: boolean },
  'creativeHub/mover/setInprogress'
>('creativeHub/mover/setInprogress');

export const copyJobAdded = createAction<
  { node: NodeLabel; target: NodeLabel; groupID?: string },
  'creativeHub/mover/copyJobAdded'
>('creativeHub/mover/copyJobAdded');

export const closeButtonClicked = createAction<void, 'creativeHub/mover/closeButtonClicked'>(
  'creativeHub/mover/closeButtonClicked',
);
export const updateState = createAction<
  {
    nodeID: number;
    state: APITaskState;
    error?: string;
  },
  'creativeHub/mover/updateState'
>('creativeHub/mover/updateState');

export const nodeCreatedForJob = createAction<
  { jobID: string; node: CHNode },
  'creativeHub/mover/nodeCreatedForJob'
>('creativeHub/mover/nodeCreatedForJob');
